/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: vuex状态管理
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-05 15:38:02
 * @LastEditTime: 2023-08-19 16:55:18
 * @FilePath: /client-h5-v2/src/store/index.ts
 */
import { createStore } from 'vuex'
import { global } from '@/store/modules/global'
import { session } from '@/store/modules/session'
import { dialog } from '@/store/modules/dialog'
import { signals } from '@/store/modules/signals'
import { login } from '@/store/modules/login'
import { radio } from '@/store/modules/radio'

export default createStore({
  state: {
  },
  mutations: {},
  actions: {},
  modules: {
    global,
    session,
    dialog,
    signals,
    login,
    radio
  }
})
